import React from "react";
import "./ApiDocumentation.css";

const ApiDocumentation = () => {
  return (
    <div className="myapi-container">
      <section className="myapi-section">
        <h2 className="myapi-heading">Introduction</h2>
        <p>Integrate Sundori Back-end API into your own application.</p>
      </section>
      <section className="myapi-section">
        <h2 className="myapi-heading">Authentication</h2>
        <p className="myapi-description">
          All API requests to the system require an API key for proper
          authentication. This API key acts as a unique identifier for each user
          and is mandatory for every request. It must be included in the body of
          the request under the parameter <code>api_key</code>. Users can obtain
          their API key by navigating to the <a href="/profile">Profile</a>{" "}
          page, where it will be displayed or available for download.
        </p>
        <p className="myapi-description">
          {" "}
          To ensure fair usage, there is a limit of 10 requests per day per
          account. If a user exceeds this limit, further requests will be
          rejected until the daily quota is reset. This limitation is in place
          to maintain the system's performance and prevent misuse.
        </p>
      </section>

      <section className="myapi-section">
        <h2 className="myapi-heading">1. Get Species Names</h2>
        <p className="myapi-description">Fetch a list of species names.</p>
        <h3 className="myapi-subheading">Endpoint</h3>
        <p className="myapi-code">
          <code>GET /myapi/species</code>
        </p>

        <h3 className="myapi-subheading">Parameters</h3>
        <ul className="myapi-list">
          <li>
            <strong>api_key</strong> (required) - Your API key for
            authentication.
          </li>
        </ul>

        <h3 className="myapi-subheading">Example Request</h3>
        <pre className="myapi-code">
          <code>GET https://api.sundori.latechnologies.net/myapi/species</code>
        </pre>

        <h3 className="myapi-subheading">Response</h3>
        <pre className="myapi-code">
          <code>["Acrostichum aureum", "Aegiceras corniculatum", ...]</code>
        </pre>
      </section>

      <section className="myapi-section">
        <h2 className="myapi-heading">2. Get Species Description</h2>
        <p className="myapi-description">
          Fetch detailed information about a species by its ID.
        </p>
        <h3 className="myapi-subheading">Endpoint</h3>
        <p className="myapi-code">
          <code>POST /myapi/description</code>
        </p>

        <h3 className="myapi-subheading">Parameters</h3>
        <ul className="myapi-list">
          <li>
            <strong>api_key</strong> (required) - Your API key for
            authentication.
          </li>
          <li>
            <strong>id</strong> (required) - The ID of the species.
          </li>
        </ul>

        <h3 className="myapi-subheading">Example Request</h3>
        <pre className="myapi-code">
          <code>
            POST https://api.sundori.latechnologies.net/myapi/description
            {"\n"}FormData: {'{ "api_key": "your_api_key", "id": "12" }'}
          </code>
        </pre>

        <h3 className="myapi-subheading">Response</h3>
        <pre className="myapi-code">
          <code>
            {"{"}
            {"\n"} "id": 12,
            {"\n"} "name_en": "Acrostichum aureum",
            {"\n"} "description": "...",
            {"\n"} "family": "...",
            {"\n"} ....
            {"\n"}
            {"}"}
          </code>
        </pre>
      </section>

      <section className="myapi-section">
        <h2 className="myapi-heading">3. Predict Species from Image</h2>
        <p className="myapi-description">
          Upload an image and get a prediction of the species.
        </p>
        <h3 className="myapi-subheading">Endpoint</h3>
        <p className="myapi-code">
          <code>POST /myapi/predict</code>
        </p>

        <h3 className="myapi-subheading">Parameters</h3>
        <ul className="myapi-list">
          <li>
            <strong>api_key</strong> (required) - Your API key for
            authentication.
          </li>
          <li>
            <strong>file</strong> (required) - The image file of the plant.
          </li>
        </ul>

        <h3 className="myapi-subheading">Example Request</h3>
        <pre className="myapi-code">
          <code>
            POST https://api.sundori.latechnologies.net/myapi/predict
            {"\n"}FormData:{" "}
            {'{ "api_key": "your_api_key", "file": "image.jpg" }'}
          </code>
        </pre>

        <h3 className="myapi-subheading">Response</h3>
        <pre className="myapi-code">
          <code>
            [{"{"}
            {"\n"} "species": "Acrostichum aureum",
            {"\n"} "species_bn": "হুদো / টাইগার ফার্ন",
            {"\n"} "index": "0"
            {"\n"}
            {"}"}, ...]
          </code>
        </pre>
      </section>
    </div>
  );
};

export default ApiDocumentation;
